const effects = {
  shadows: [
    '0px 10px 20px rgba(39, 155, 229, 0.2)',
    '0px 10px 20px rgba(48, 48, 48, 0.2)',
    '2px 2px 4px rgba(0, 0, 0, 0.5)',
  ],
};

export default effects;
